import React from 'react';
import './Chat.css'; // Optional: add styles here
import { MdEmail } from 'react-icons/md';

function Chat
() {
  return <div className='chat'>
     <a href="https://topmate.io/aadhaar_koul">
        <MdEmail size={24} style={{ marginRight: '8px' }} />
        <span>Let's Chat</span>
      </a>
  </div>
}

export default Chat
;
